module.exports = __webpack_public_path__ + "static/media/Myself1.c5ac02bc.jpeg";